import { render, staticRenderFns } from "./PolicyFlexiblePathDownloadModal.vue?vue&type=template&id=867ca03c&"
import script from "./PolicyFlexiblePathDownloadModal.vue?vue&type=script&lang=js&"
export * from "./PolicyFlexiblePathDownloadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports